@if (loadedError) {
    <app-widgets-overlay [type]="loadedErrorReason"></app-widgets-overlay>
}
@if (!loadedError && loaded && !data) {
    <app-widgets-overlay type="no-match"></app-widgets-overlay>
}
@if (loaded) {
    <div class="widget-container d-flex flex-column">
        <div class="widget-container__object">
            @if (!noTitle) {
                <h1 class="widget-title align-self-center">
                    {{ 'web.widget_corners_last10games' | translate }}
                </h1>
            }
            <div class="d-flex">
                @if (data?.home; as p) {
                    <div class="widget-team mt-1 d-flex flex-column" data-cy="team">
                        <div class="widget-team__name d-flex align-items-center">
                            <img
                                (error)="imageError($event)"
                                [attr.src]="p.image | responsive: 'participant' : 'medium'"
                                [alt]="p.name"
                                class="img-fluid app-cursor mr-1"
                            />
                            <div>{{ p.name }}</div>
                        </div>
                    </div>
                }
                @if (data?.away; as p) {
                    <div class="widget-team mt-1 d-flex flex-column widget-team--second" data-cy="team">
                        <div class="widget-team__name d-flex align-items-center justify-content-end">
                            <div>{{ p.name }}</div>
                            <img
                                (error)="imageError($event)"
                                [attr.src]="p.image | responsive: 'participant' : 'medium'"
                                [alt]="p.name"
                                class="img-fluid app-cursor ml-1"
                            />
                        </div>
                    </div>
                }
            </div>
            <!-- Corners -->
            <div class="d-flex flex-column widget-form-participant-container">
                <div class="d-flex justify-content-between">
                    <div class="widget-form-participant widget-form-participant--home">&nbsp;</div>
                    <div class="widget-form-participant-text font-weight-bold font-1-1x">
                        {{ 'web.avg_corners' | translate }}
                    </div>
                    <div class="widget-form-participant widget-form-participant--away">&nbsp;</div>
                </div>
                <div class="d-flex justify-content-around">
                    <app-chart-circle-somple [percentage]="homeWidth" [text]="data?.home?.name" data-cy="cornersHome">
                        @if (cornersHome !== 'Ndf') {
                            {{ cornersHome | number: '1.0-1' }}
                        }
                        @if (cornersHome === 'Ndf') {
                            {{ cornersHome }}
                        }
                    </app-chart-circle-somple>
                    <app-chart-circle-somple [percentage]="awayWidth" [text]="data?.away?.name" data-cy="cornersAway">
                        @if (cornersAway !== 'Ndf') {
                            {{ cornersAway | number: '1.0-1' }}
                        }
                        @if (cornersAway === 'Ndf') {
                            {{ cornersAway }}
                        }
                    </app-chart-circle-somple>
                </div>
            </div>
            <!-- Corners Home-->
            <div class="d-flex flex-column widget-form-participant-container">
                <div class="d-flex justify-content-between">
                    <div class="widget-form-participant widget-form-participant--home"></div>
                    <div class="widget-form-participant-text align-self-end">
                        {{ 'web.avg_corners_home' | translate }}
                    </div>
                    <div class="widget-form-participant widget-form-participant--away"></div>
                </div>
                <div class="d-flex">
                    <div
                        class="widget-form-participant-bar widget-form-participant-bar--home"
                        [style.width.%]="homeHomeWidth"
                    >
                        @if (cornersHomeHome !== 'Ndf') {
                            {{ cornersHomeHome | number: '1.0-1' }}
                        }
                    </div>
                    <div
                        class="widget-form-participant-bar widget-form-participant-bar--away"
                        [style.width.%]="awayHomeWidth"
                    >
                        @if (cornersAwayHome !== 'Ndf') {
                            {{ cornersAwayHome | number: '1.0-1' }}
                        }
                    </div>
                </div>
            </div>
            <!-- Corners Away-->
            <div class="d-flex flex-column widget-form-participant-container">
                <div class="d-flex justify-content-between">
                    <div class="widget-form-participant widget-form-participant--home"></div>
                    <div class="widget-form-participant-text align-self-end">
                        {{ 'web.avg_corners_away' | translate }}
                    </div>
                    <div class="widget-form-participant widget-form-participant--away"></div>
                </div>
                <div class="d-flex">
                    <div
                        class="widget-form-participant-bar widget-form-participant-bar--home"
                        [style.width.%]="homeAwayWidth"
                    >
                        @if (cornersHomeHome !== 'Ndf') {
                            {{ cornersHomeAway | number: '1.0-1' }}
                        }
                    </div>
                    <div
                        class="widget-form-participant-bar widget-form-participant-bar--away"
                        [style.width.%]="awayAwayWidth"
                    >
                        @if (cornersAwayHome !== 'Ndf') {
                            {{ cornersAwayAway | number: '1.0-1' }}
                        }
                    </div>
                </div>
            </div>
            <div class="w-100 text-center widget-form-participant-text app-word-nowrap">
                {{ 'web.num_of_matches' | translate }} ({{ num }})
            </div>
            <div class="widget-logo d-flex justify-content-center mt-4">
                <img
                    [src]="'/img/' + client.getName() + '.png'"
                    [alt]="client.getName()"
                    data-cy="logo"
                    class="widget-logo-client"
                />
            </div>
        </div>
    </div>
}
